import { InlineMessage } from '@strata/react-inline-message';
import PropTypes from 'prop-types';

import { PrescriberDeactivatedBanner } from 'pages/npiManagement/PrescriberDeactivatedBanner';
import { PrescriberDetailsFormFields } from 'pages/npiManagement/PrescriberDetailsFormFields';

const PrescriberOverrideOrderlyMessage = ({ onRestore }) => (
    <div className="padding__bottom--small">
        <InlineMessage
            intent={InlineMessage.Intent.INFO}
            label={
                <>
                    <span className="margin__right--small">
                        This record was overwritten and will no longer receive Orderly updates.
                    </span>
                    <u
                        role="button"
                        tabIndex={0}
                        onClick={onRestore}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                onRestore();
                            }
                        }}
                    >
                        Restore to Default
                    </u>
                </>
            }
        />
    </div>
);

PrescriberOverrideOrderlyMessage.propTypes = {
    onRestore: PropTypes.func.isRequired,
};

const PrescriberDetailsStatusMessage = ({ loadState, npi }) => {
    if (loadState.kind === 'not_found') {
        return (
            <InlineMessage
                intent={InlineMessage.Intent.WARNING}
                label={`No prescriber was found for NPI ${npi}.`}
            />
        );
    }

    if (loadState.kind === 'error') {
        return (
            <InlineMessage
                intent={InlineMessage.Intent.ERROR}
                label="Unable to load prescriber details. Return to search and try again."
            />
        );
    }

    return null;
};

PrescriberDetailsStatusMessage.propTypes = {
    loadState: PropTypes.shape({
        kind: PropTypes.string.isRequired,
    }).isRequired,
    npi: PropTypes.string.isRequired,
};

export const PrescriberDetailsFormContent = ({
    npi,
    loadState,
    prescriber = undefined,
    formik,
    isCreate,
    isReadOnly,
    isDeactivated,
    hasPracticeNpi,
    isReactivating,
    onReactivate,
    onRestoreOrderly,
}) => (
    <>
        {isDeactivated && (
            <PrescriberDeactivatedBanner
                npi={npi}
                message={loadState.message}
                onReactivate={onReactivate}
                isReactivating={isReactivating}
            />
        )}
        <PrescriberDetailsStatusMessage loadState={loadState} npi={npi} />
        {prescriber?.override_orderly && !isDeactivated && (
            <PrescriberOverrideOrderlyMessage onRestore={onRestoreOrderly} />
        )}
        {(isCreate || prescriber) && (
            <PrescriberDetailsFormFields
                formik={formik}
                isCreate={isCreate}
                isReadOnly={isReadOnly}
                hasPracticeNpi={hasPracticeNpi}
            />
        )}
    </>
);

PrescriberDetailsFormContent.propTypes = {
    npi: PropTypes.string.isRequired,
    loadState: PropTypes.shape({
        kind: PropTypes.string.isRequired,
        message: PropTypes.string,
    }).isRequired,
    prescriber: PropTypes.shape({
        override_orderly: PropTypes.bool,
    }),
    formik: PropTypes.shape({}).isRequired,
    isCreate: PropTypes.bool.isRequired,
    isReadOnly: PropTypes.bool.isRequired,
    isDeactivated: PropTypes.bool.isRequired,
    hasPracticeNpi: PropTypes.bool.isRequired,
    isReactivating: PropTypes.bool.isRequired,
    onReactivate: PropTypes.func.isRequired,
    onRestoreOrderly: PropTypes.func.isRequired,
};
